const TOKEN_KEY = 'token'

export function getToken() {
  let token = localStorage.getItem(TOKEN_KEY) || ''
  if (!token || token === 'undefined' || token === 'null') {
    token = sessionStorage.getItem(TOKEN_KEY) || ''
    if (!token || token === 'undefined' || token === 'null') return ''
    localStorage.setItem(TOKEN_KEY, token)
  }
  if (sessionStorage.getItem(TOKEN_KEY) !== token) {
    sessionStorage.setItem(TOKEN_KEY, token)
  }
  return token
}

export function setToken(token) {
  token = token || ''
  if (!token || token === 'undefined' || token === 'null') {
    localStorage.removeItem(TOKEN_KEY)
    sessionStorage.removeItem(TOKEN_KEY)
    return
  }
  localStorage.setItem(TOKEN_KEY, token)
  sessionStorage.setItem(TOKEN_KEY, token)
}

export function clearAuthStorage() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem('userInfo')
  sessionStorage.removeItem(TOKEN_KEY)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js